import { Directive, OnInit, OnDestroy, HostListener, ElementRef, Input } from '@angular/core';

import { NgControl } from '@angular/forms';

import { BcLocalizedNumbersService } from '../../shared/services';

import { Subscription } from 'rxjs';
import { distinctUntilChanged, map, tap } from 'rxjs/operators';

@Directive({
  selector: '[bcPercentage]',
})
export class BcPercentageDirective implements OnInit, OnDestroy {
  @Input() fractionDigits: number;

  private disposeValueChanges: Subscription;

  constructor(private ngControl: NgControl,
              private elementRef: ElementRef,
              private localizedNumbersService: BcLocalizedNumbersService) { }

  @HostListener('focus') onFocus() {
    this.elementRef.nativeElement.select();
  }

  @HostListener('blur') onBlur() {
    const value = this.localizedNumbersService.formatValue(this.ngControl.control.value, this.fractionDigits);
    this.ngControl.control.setValue(value);
  }

  ngOnInit() {
    this.disposeValueChanges = this.ngControl.valueChanges
    .pipe(
      distinctUntilChanged(),
      map((v: string) => this.localizedNumbersService.formatValue(v)),
      tap((v: string) => this.ngControl.control.setValue(v))
    ).subscribe();

    const initFormatted = this.localizedNumbersService.formatValue(this.ngControl.control.value);
    this.ngControl.control.setValue(initFormatted);
  }

  ngOnDestroy() {
    this.disposeValueChanges.unsubscribe();
  }
}
